import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { n: 1, label: "Upload & Config" },
  { n: 2, label: "Calibration (optional)" },
  { n: 3, label: "Sequence Lab" },
];

export default function WizardProgress({ current }) {
  return (
    <div className="px-8 pt-6 pb-4 border-b border-border bg-card/40">
      <div className="flex items-center gap-2">
        {STEPS.map((s, i) => {
          const done = s.n < current;
          const active = s.n === current;
          return (
            <React.Fragment key={s.n}>
              <div className="flex items-center gap-3 min-w-0">
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-sm border font-mono text-xs font-bold transition-colors
                    ${
                      done
                        ? "bg-primary border-primary text-primary-foreground"
                        : active
                        ? "bg-accent border-primary text-primary"
                        : "bg-card border-border text-muted-foreground"
                    }`}
                >
                  {done ? <Check className="w-3.5 h-3.5" strokeWidth={3} /> : s.n}
                </div>
                <div className="hidden md:block min-w-0">
                  <div
                    className={`font-mono text-[10px] uppercase tracking-widest ${
                      active ? "text-primary" : "text-muted-foreground"
                    }`}
                  >
                    Step {s.n}
                  </div>
                  <div
                    className={`text-sm font-medium truncate ${
                      active || done ? "text-foreground" : "text-muted-foreground"
                    }`}
                  >
                    {s.label}
                  </div>
                </div>
              </div>
              {i < STEPS.length - 1 && (
                <div
                  className={`flex-1 h-[2px] ${
                    s.n < current ? "bg-primary" : "bg-border"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
